import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot, ActivatedRoute
}                           from '@angular/router';
import { AuthService }      from './auth.service';
import {Observable} from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

import { HttpModule } from '@angular/http';
import {Injectable, Inject} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import { API_URL } from './globals';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router, private http: Http) {}

  canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : Observable<boolean> {
    let url: string = state.url;
    if(localStorage.getItem('currentUserRoleId')) {
      return this.roleCheck(url,route.data.nav)
      .map(roleaccess =>  {
        localStorage.setItem('currentUserMainPermissions',roleaccess.permission);
        localStorage.setItem('currentUserInnerPermissions', roleaccess.permissionInside);
        if((roleaccess.permission).indexOf(route.data.nav) > -1){
            console.log("true");
            return true;
         } else {
            console.log("false");
            return false;
         }
      });    
    } else if(localStorage.getItem('currentUserRole')) {
      localStorage.setItem('currentUserMainPermissions', 'dashboard');
      localStorage.setItem('currentUserInnerPermissions', '');
      console.log("true");
      return Observable.of(true);
    }
  }

  roleCheck(url: string, nav: string) : Observable<any> {
    let options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');
    options.headers.append('Accept', 'application/json');

    return this.http.get(API_URL+'/Roles?filter={"where":{"id":"'+localStorage.getItem('currentUserRoleId')+'"}}&access_token='+ localStorage.getItem('currentUserToken'), options)
    .map(res => res.json()[0]);  
  }
}


// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/auth-guard.service.ts